import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { AccountResult, AnalyticsResultsService } from 'src/app/shared/services/analytics-results.service';

@Component({
  selector: 'app-accounts-list',
  templateUrl: './accounts-list.component.html',
  styleUrls: ['../widgets.scss', './accounts-list.component.scss']
})
export class AccountsListComponent implements OnInit {

  isMobile: boolean = false;
  accounts: AccountResult[] = new Array<AccountResult>();
  accountsLoaded: boolean = false;
  accountsColumns: string[] = ["colLogo", "colName", "colCurBal"];

  constructor(private resultsAnalyticsSvc: AnalyticsResultsService, private breakpointObserver: BreakpointObserver){
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      if (result.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
  }
  
  ngOnInit(): void {
    this.resultsAnalyticsSvc.getBankAccounts()
      .subscribe({
        next: (data) => {
          this.accounts = data;
          this.accountsLoaded = true;
        }
      });
  }



}
